function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 0C5.36756 0 0 5.36705 0 12C0 18.6325 5.36705 24 12 24C18.6324 24 24 18.633 24 12C24 5.36752 18.633 0 12 0Z",
  fill: "var(--k-fg-eb5757)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.1056 14.7797L13.3258 12L16.1056 9.22017C16.4716 8.85408 16.4717 8.2605 16.1056 7.89436C15.7394 7.52822 15.1458 7.52826 14.7798 7.89436L12 10.6741L9.22014 7.89436C8.8541 7.52822 8.26043 7.52822 7.89433 7.89436C7.52824 8.2605 7.52824 8.85408 7.89438 9.22017L10.6742 12L7.89438 14.7797C7.52824 15.1459 7.52819 15.7395 7.89433 16.1055C8.26057 16.4717 8.85414 16.4716 9.22014 16.1055L12 13.3258L14.7798 16.1055C15.1458 16.4716 15.7395 16.4717 16.1056 16.1055C16.4717 15.7394 16.4717 15.1458 16.1056 14.7797Z",
  fill: "white"
});

function SvgCircleError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleError);
export default __webpack_public_path__ + "static/media/circle-error.35394e4d.svg";
export { ForwardRef as ReactComponent };